export default "__VITE_ASSET__cjvPvDEp__"